export default "__VITE_ASSET__J0XRIU2Z__"